
















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { LoadingService } from '@/services/loadingService';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { Validator } from 'vee-validate';
import { ControlPatentesInterfaces } from '@/pantallas/TorreControl/ControlPatentes/controlPatentesInterfaces';
import { configService } from '@/pantallas/TorreControl/ControlConfiguracion/configService';

@Component({
  name: 'CustomDashboard',
  components: {
    FormFieldsContainer,
  },
})
export default class CustomDashboard extends Vue {
  clientId: string;
  isFormValid: boolean = true;
  customName: string = '';
  emailsError: string = '';
  fileName: string = '';
  idkey: number = 0;
  file_b64: any = null;
  fileSize: number = 0;
  activeCustom: boolean = false;
  loadingService = new LoadingService();
  ConfigService = new configService();
  $snotify: any;
  hint: string = 'Al activar se cambiara la forma de visualizar el dashboard.';

  created() {
    let self = this;
    this.clientId = localStorage.getItem('clienteDefecto');
    this.getData();
    Validator.extend('tamanio', {
      getMessage(field: any, params: any, data: any) {
        return (
          (data && data.message) ||
          '* El peso del archivo no puede superar los 5 MB'
        );
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: self.validaTamano(),
            data: self.validaTamano()
              ? undefined
              : { message: '* El peso del archivo no puede superar los 5 MB' },
          });
        });
      },
    });
  }

  validaTamano() {
    if (this.fileName != '') {
      if (this.fileSize > 0 && this.fileSize <= 5119612) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async handleClick() {
    let data = {
      clientId: this.clientId,
      name: this.customName,
      filename: this.fileName == null ? '' : this.fileName,
      active: this.activeCustom,
      fileSize: this.fileSize,
      fileB64: this.file_b64,
    };
    const resultadoValidacion = await this.$validator.validateAll();
    if (resultadoValidacion) {
      const axiosResponse: AxiosResponse<
        MSResponse<ControlPatentesInterfaces>
      > = await this.ConfigService.saveCustomConfig(data);
      const msResponse: any = axiosResponse.data;
      if (msResponse.CODIGO_RESPUESTA == '1') {
        this.$snotify.success(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
        this.fileName = '';
      } else {
        this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  onFilePicked(e: any) {
    let self = this;
    if (!this.activeCustom) {
      this.$snotify.error(
        'Debe activar la personalización antes de cargar el archivo.',
        {
          timeout: 3000,
        }
      );
      return;
    }
    var tgt = e.target || window.event.srcElement,
      files = tgt.files;
    this.fileName = files[0].name;
    const allowedExtensions = /\.xlsx$/i;
    if (!allowedExtensions.test(this.fileName)) {
      // El archivo no tiene la extensión .xlsx
      // this.fileName = '';
      this.$snotify.error('Formato del archivo debe ser xlsx', {
        timeout: 3000,
      });
      return;
    }
    if (FileReader && files && files.length) {
      this.fileSize = files[0].size;
      var fr = new FileReader();

      fr.onload = function() {
        var base64 = fr.result;
        self.file_b64 = base64;
      };
      fr.readAsDataURL(files[0]);
    }
    this.idkey += 1;
  }

  async getData() {
    const axiosResponse: AxiosResponse<
      MSResponse<ControlPatentesInterfaces>
    > = await this.ConfigService.getData(this.clientId);
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.customName = msResponse.name_custom;
      this.activeCustom = msResponse.active_custom;
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
  }

  onBtnDwnld() {
    const url =
      window.location.origin + '/plantillas/Plantilla_personalizacion.xlsx';
    window.open(url, '_blank');
  }

  cleanInput() {
    if (!this.activeCustom) {
      this.customName = '';
      this.fileName = '';
    }
  }
}
